import script from "./IndexPagenation.vue?vue&type=script&lang=ts&setup=true"
export * from "./IndexPagenation.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__